var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSound = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.835 17.5C24.835 14.0332 22.7158 11.0645 19.708 9.80957L18.9072 11.7334C21.1631 12.6758 22.75 14.9023 22.75 17.5C22.75 20.1025 21.1631 22.3242 18.9023 23.2666L19.7031 25.1904C22.7158 23.9355 24.835 20.9668 24.835 17.5ZM20.665 17.5C20.665 15.7666 19.6055 14.2822 18.1016 13.6572L17.3008 15.5811C18.0527 15.8936 18.5801 16.6357 18.5801 17.5049C18.5801 18.3691 18.0527 19.1113 17.3008 19.4287L18.1016 21.3525C19.6055 20.7178 20.665 19.2334 20.665 17.5ZM21.3096 5.96191L20.5039 7.88574C24.2686 9.45312 26.915 13.1641 26.915 17.5C26.915 21.8311 24.2686 25.5469 20.5039 27.1143L21.3047 29.0381C25.8262 27.1533 29 22.7002 29 17.5C29 12.2998 25.8262 7.84668 21.3096 5.96191ZM4 12.29V22.7051H8.16504L15.46 30V5L8.16504 12.29H4Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Sound.3e0b9fdcf4d0a1ca73c619477e157e3e.svg";